export default class DebugState {
  static isDebugJavaScript: boolean = false;
}
